/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIShippingStatusEnum } from './APIShippingStatusEnum';
import {
    APIShippingStatusEnumFromJSON,
    APIShippingStatusEnumFromJSONTyped,
    APIShippingStatusEnumToJSON,
} from './APIShippingStatusEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIShipping
 */
export interface APIShipping {
    /**
     * 
     * @type {string}
     * @memberof APIShipping
     */
    readonly self: string;
    /**
     * 
     * @type {number}
     * @memberof APIShipping
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof APIShipping
     */
    amount: number;
    /**
     * 
     * @type {Date}
     * @memberof APIShipping
     */
    dueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIShipping
     */
    wishDate: Date;
    /**
     * 
     * @type {string}
     * @memberof APIShipping
     */
    address: string;
    /**
     * 
     * @type {APIShippingStatusEnum}
     * @memberof APIShipping
     */
    shippingStatus: APIShippingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof APIShipping
     */
    trackingNumber: string;
}



/**
 * Check if a given object implements the APIShipping interface.
 */
export function instanceOfAPIShipping(value: object): value is APIShipping {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('wishDate' in value) || value['wishDate'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('shippingStatus' in value) || value['shippingStatus'] === undefined) return false;
    if (!('trackingNumber' in value) || value['trackingNumber'] === undefined) return false;
    return true;
}

export function APIShippingFromJSON(json: any): APIShipping {
    return APIShippingFromJSONTyped(json, false);
}

export function APIShippingFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIShipping {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'id': json['id'],
        'amount': json['amount'],
        'dueDate': (new Date(json['due_date'])),
        'wishDate': (new Date(json['wish_date'])),
        'address': json['address'],
        'shippingStatus': APIShippingStatusEnumFromJSON(json['shipping_status']),
        'trackingNumber': json['tracking_number'],
    };
}

export function APIShippingToJSON(value?: Omit<APIShipping, 'self'|'id'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'due_date': ((value['dueDate']).toISOString()),
        'wish_date': ((value['wishDate']).toISOString()),
        'address': value['address'],
        'shipping_status': APIShippingStatusEnumToJSON(value['shippingStatus']),
        'tracking_number': value['trackingNumber'],
    };
}

